module.exports = __webpack_public_path__ + "static/img/product07-5.c2ebd7cf.png";